"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateStepOutput = void 0;
const shared_models_1 = require("@railgun-community/shared-models");
const validateStepOutput = (input, output) => {
    try {
        validateStepOutputERC20Amounts(input, output);
        validateStepOutputNFTs(input, output);
    }
    catch (err) {
        throw new Error(`Validation Error: ${err.message}`);
    }
};
exports.validateStepOutput = validateStepOutput;
const getTokenId = (tokenAddress, isBaseToken) => {
    const lcToken = tokenAddress.toLowerCase();
    return (0, shared_models_1.isDefined)(isBaseToken) && isBaseToken ? `${lcToken}-base` : lcToken;
};
const validateStepOutputERC20Amounts = (input, output) => {
    const inputERC20AmountMap = {};
    const outputERC20AmountMap = {};
    input.erc20Amounts.forEach(({ tokenAddress, expectedBalance, isBaseToken }) => {
        const id = getTokenId(tokenAddress, isBaseToken);
        inputERC20AmountMap[id] ?? (inputERC20AmountMap[id] = 0n);
        inputERC20AmountMap[id] = inputERC20AmountMap[id] + expectedBalance;
    });
    output.outputERC20Amounts.forEach(({ tokenAddress, expectedBalance, minBalance, isBaseToken }) => {
        const id = getTokenId(tokenAddress, isBaseToken);
        outputERC20AmountMap[id] ?? (outputERC20AmountMap[id] = 0n);
        outputERC20AmountMap[id] = outputERC20AmountMap[id] + expectedBalance;
        if (expectedBalance < minBalance) {
            throw new Error('Min balance must be >= expected balance.');
        }
    });
    const eradicatedERC20Amounts = [
        ...(output.spentERC20Amounts ?? []),
        ...(output.feeERC20AmountRecipients ?? []),
    ];
    eradicatedERC20Amounts.forEach(({ tokenAddress, amount, isBaseToken }) => {
        const id = getTokenId(tokenAddress, isBaseToken);
        outputERC20AmountMap[id] ?? (outputERC20AmountMap[id] = 0n);
        outputERC20AmountMap[id] = outputERC20AmountMap[id] + amount;
    });
    for (const id in inputERC20AmountMap) {
        if (!(0, shared_models_1.isDefined)(outputERC20AmountMap[id])) {
            throw new Error(`Missing output for ${id}.`);
        }
        if (outputERC20AmountMap[id] === 0n) {
            throw new Error(`Missing output value for ${id}.`);
        }
        if (inputERC20AmountMap[id] !== outputERC20AmountMap[id]) {
            throw new Error(`Input erc20 amounts for ${id} (${inputERC20AmountMap[id]}) must match total outputs/spent/fees (${outputERC20AmountMap[id]}).`);
        }
    }
};
const validateStepOutputNFTs = (input, output) => {
    const inputNFTMap = {};
    const outputNFTMap = {};
    input.nfts.forEach(({ nftAddress, tokenSubID, amount }) => {
        inputNFTMap[nftAddress] ?? (inputNFTMap[nftAddress] = {});
        if (amount > 1n) {
            throw new Error('NFTs must have amount 1');
        }
        if (inputNFTMap[nftAddress][tokenSubID]) {
            throw new Error(`Duplicate NFT input for ${nftAddress}: ${tokenSubID}`);
        }
        inputNFTMap[nftAddress][tokenSubID] = 1n;
    });
    const nftOutputs = [
        ...(output.spentNFTs ?? []),
        ...(output.outputNFTs ?? []),
    ];
    nftOutputs.forEach(({ nftAddress, tokenSubID, amount }) => {
        outputNFTMap[nftAddress] ?? (outputNFTMap[nftAddress] = {});
        if (amount > 1n) {
            throw new Error('NFTs must have amount 1');
        }
        if (outputNFTMap[nftAddress][tokenSubID]) {
            throw new Error(`Duplicate NFT input for ${nftAddress}: ${tokenSubID}`);
        }
        outputNFTMap[nftAddress][tokenSubID] = 1n;
    });
    for (const nftAddress in inputNFTMap) {
        for (const tokenSubID in inputNFTMap[nftAddress]) {
            if (!outputNFTMap[nftAddress]?.[tokenSubID]) {
                throw new Error(`Input NFT ${nftAddress}:${tokenSubID} must match NFT output.`);
            }
        }
    }
};
